var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 290 290"}},_vm.$listeners),[_c('path',{attrs:{"d":"M165 0h125v125H165zM0 0h125v125H0zM0 165h125v125H0zM165 165h125v125H165z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }